import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import moment from "Helpers/MomentCompat";
import { showNotification } from "Helpers/Toast";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseServices from "Hooks/UseServices";

import Button from "Components/Global/Buttons";

import * as S from "./styles";

const SponsorOrders = ({ projectId }) => {
  const { api } = UseServices();
  const { loading } = UseGlobalLoading();

  const [orders, setOrders] = useState([]);

  useEffect(() => {
    return getProjectSponsorOrders(projectId);

    // eslint-disable-next-line
  }, []);

  const getProjectSponsorOrders = (project_id) => {
    api
      .post("/projects/get-project-sponsor-orders", {
        project_id: project_id,
      })
      .then((response) => {
        const orders = response.data;

        setOrders(orders);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  const updateProjectSponsorOrder = (order_id, status) => {
    api
      .post("/projects/update-project-sponsor-order-status", {
        order_id,
        status,
      })
      .then(() => {
        showNotification(
          "success",
          "Sucesso!",
          "Pedido atualizado com sucesso!",
        );

        getProjectSponsorOrders(projectId);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  return (
    <S.Wrapper>
      {/* Havia aqui um <CounterpartForm> condicionado a `selectedOrder` —
          CÓDIGO MORTO: nenhum card setava esse estado, então o formulário nunca
          abria (e ia sem `sponsorOptions`/`statusOptions`, o que renderizaria
          selects vazios). Removido em 03/09/2026 junto com o formulário de
          contrapartida da área comum, cuja escrita passou a ser exclusiva do
          admin (D10 da parte 2). A lista de pedidos e os botões
          Autorizar/Reprovar continuam intactos. */}
      <Form>
        <S.Section>
          <span>Pedidos de Patrocínio para Empresas Validadas</span>
          <hr />
        </S.Section>

        {!orders.length ? <span>Nenhum pedido cadastrado.</span> : null}

        {orders?.map((order) => (
          <S.Counterpart key={order.id}>
            <S.CounterpartInfos>
              <S.Header>
                <h2>{order.sponsor?.full_name}</h2>
              </S.Header>
              <span>
                Status: <strong>{order.status}</strong>
              </span>
              {order.status === "Aprovado" && (
                <span>
                  Aprovado em:{" "}
                  <strong>
                    {moment(order.approved_at).format("DD/MM/YYYY HH:mm")}
                  </strong>
                </span>
              )}
              <p>{order.text}</p>

              {order.status === "Pendente" ? (
                <S.Buttons>
                  <Button
                    type="button"
                    variant="critical"
                    text="Reprovar"
                    disabled={loading}
                    onClick={() =>
                      updateProjectSponsorOrder(order.id, "Reprovado")
                    }
                  />
                  <Button
                    type="button"
                    variant="success"
                    text="Autorizar"
                    disabled={loading}
                    onClick={() =>
                      updateProjectSponsorOrder(order.id, "Aprovado")
                    }
                  />
                </S.Buttons>
              ) : null}
            </S.CounterpartInfos>
          </S.Counterpart>
        ))}
      </Form>
    </S.Wrapper>
  );
};

export default SponsorOrders;
